module.exports = __webpack_public_path__ + "img/parner1.b756df15.png";